var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting_ps px-7 py-4 overflow-y-auto"},[_c('div',{staticClass:"width-100 height-100 display-flex flex-column"},[_c('div',{staticClass:"display-flex flex-row flex-justify-space-between mb-12"},[_c('ManageAppsHeaderExplanations'),_c('ManageAppsSelectFavoriteMenu')],1),_c('ManageAppsFavoriteAppsList',{staticClass:"pb-4"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }